export default "__VITE_ASSET__MQgs3y2S__"